"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSankeyMenuConfigurationLegend = void 0;
const react_bootstrap_1 = require("react-bootstrap");
const react_1 = __importDefault(require("react"));
const OpenSankeyMenuConfigurationLegend = (data, set_data, t, legend_position, set_legend_position) => {
    return [
        /* Position X de la legende  */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.LegX'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.LegX', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.LegX' },
                        t('Menu.tooltips.LegX'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: legend_position[0], onChange: evt => set_legend_position([+evt.target.value, legend_position[1]]), onBlur: () => {
                            data.legend_position = legend_position;
                            set_data(Object.assign({}, data));
                        } })))),
        /* Position Y de la legende */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.LegY'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.LegY', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.LegY' },
                        t('Menu.tooltips.LegY'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: legend_position[1], onChange: evt => set_legend_position([legend_position[0], +evt.target.value]), onBlur: () => {
                            data.legend_position = legend_position;
                            set_data(Object.assign({}, data));
                        } })))),
        /* Largeur de la fenetre de legende */
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.LegWidth'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.LegWidth', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.LegWidth' },
                        t('Menu.tooltips.LegWidth'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormControl, { type: "number", step: 1, value: data.legend_width, onChange: evt => {
                            data.legend_width = +evt.target.value;
                            set_data(Object.assign({}, data));
                        } }))))
    ];
};
exports.OpenSankeyMenuConfigurationLegend = OpenSankeyMenuConfigurationLegend;
